var styleDataHash = "9a092356";
const injectCss = () => {
  var css = `.R6qTj{position:absolute}[dir=ltr] .R6qTj{right:10px}[dir=rtl] .R6qTj{left:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var CustomHeadingButton_default = {
  "toolbarLabelUpdate": "R6qTj"
};
export {
  CustomHeadingButton_default as default,
  injectCss
};
//# sourceMappingURL=CustomHeadingButton-scss.js.map
